/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default () => {
  const lessonSubtitlesBlock = document.getElementById('subtitles-block');
  // 字幕機能が無効場合
  if (!lessonSubtitlesBlock) return;

  const subtitleChoices = Array.from(document.getElementsByClassName('subtitle-choice'));
  // 利用可能な字幕言語がない場合
  if (subtitleChoices.length === 0) return;

  const lessonChoices = Array.from(document.getElementsByClassName('lesson-choice'));
  const currentDefaultLanguage = localStorage.getItem('subtitleDefaultLanguage');

  window.addEventListener('load', () => {
    // 複数の学科がない場合は、ページ読み込み時に字幕選択を表示
    if (lessonChoices.length === 0) {
      lessonSubtitlesBlock.classList.remove('d-none');
    } else {
      // 学科が選択された際、その学科の字幕選択肢を表示する
      lessonChoices.forEach((lessonRadio) => {
        lessonRadio.addEventListener('change', (e) => {
          const { target } = e;
          if (!(target instanceof HTMLInputElement)) return;

          lessonSubtitlesBlock.classList.remove('d-none');

          subtitleChoices.forEach((subtitleSelect) => {
            if (!(subtitleSelect instanceof HTMLSelectElement)) return;
            const selectElement = subtitleSelect;
            const { lessonCode } = selectElement.dataset;
            const isActive = lessonCode === target.value;
            selectElement.style.display = isActive ? '' : 'none';
            selectElement.disabled = !isActive;
          });
        });
      });
    }
  });

  subtitleChoices.forEach((subtitleSelect) => {
    if (!(subtitleSelect instanceof HTMLSelectElement)) return;

    // localStorageに基づいて、デフォルトで選択されるオプションを設定する
    const { options } = subtitleSelect;
    Array.from(options).forEach((option) => {
      if (!(option instanceof HTMLOptionElement)) return;
      const opt = option;
      if (opt.value === currentDefaultLanguage) {
        opt.selected = true;
      }
    });

    // 字幕言語を選択するとき
    subtitleSelect.addEventListener('change', (e) => {
      const { target } = e;
      if (!(target instanceof HTMLSelectElement)) return;
      localStorage.setItem('subtitleDefaultLanguage', target.value);
    });
  });
};
